export default __webpack_public_path__ + "static/media/graphic-4.20e16ae7.png";